var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('invoice-list',{model:{value:(_vm.invoices),callback:function ($$v) {_vm.invoices=$$v},expression:"invoices"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }